import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** SHARED_ENUMS / phase 1: OTP is six digits. */
export const OTP_LENGTH = 6;

export function isValidOtp(value: string, length = OTP_LENGTH): boolean {
  return new RegExp(`^\\d{${length}}$`).test(value);
}

/** Keeps only digits - what the six-box entry stores after a paste. */
export function digitsOnly(value: string, max = OTP_LENGTH): string {
  return value.replace(/\D/g, '').slice(0, max);
}

/**
 * Exactly `length` digits.
 *
 * Empty is VALID, so `required` owns the blank case and a half-typed code
 * shows one message rather than two. `otpLength` carries the expected and
 * actual counts so the template can say "2 of 6 digits" instead of just
 * "invalid".
 */
export function otpValidator(length = OTP_LENGTH): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw: unknown = control.value;
    if (raw === null || raw === undefined || raw === '') return null;
    if (typeof raw !== 'string') return { otp: true };
    if (isValidOtp(raw, length)) return null;
    return { otp: true, otpLength: { required: length, actual: digitsOnly(raw, length).length } };
  };
}
